import { Icon } from '../Icon';
import type { IconProps } from '../types';

export function SearchIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M11 4a7 7 0 1 0 0 14 7 7 0 0 0 0-14m-9 7a9 9 0 1 1 16.032 5.618l3.675 3.675a1 1 0 0 1-1.414 1.414l-3.675-3.675A9 9 0 0 1 2 11" />
    </Icon>
  );
}

SearchIcon.displayName = 'SearchIcon';
